var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0006 22.3757H8.00063C6.68063 22.3757 5.58063 22.2458 4.65063 21.9658C4.31063 21.8658 4.09063 21.5357 4.11063 21.1857C4.36063 18.1957 7.39063 15.8457 11.0006 15.8457C14.6106 15.8457 17.6306 18.1857 17.8906 21.1857C17.9206 21.5457 17.7006 21.8658 17.3506 21.9658C16.4206 22.2458 15.3206 22.3757 14.0006 22.3757ZM5.72063 20.6857C6.38063 20.8157 7.13063 20.8757 8.00063 20.8757H14.0006C14.8706 20.8757 15.6206 20.8157 16.2806 20.6857C15.7506 18.7657 13.5606 17.3457 11.0006 17.3457C8.44063 17.3457 6.25063 18.7657 5.72063 20.6857Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 1.625H8C3 1.625 1 3.625 1 8.625V14.625C1 18.405 2.14 20.475 4.86 21.245C5.08 18.645 7.75 16.595 11 16.595C14.25 16.595 16.92 18.645 17.14 21.245C19.86 20.475 21 18.405 21 14.625V8.625C21 3.625 19 1.625 14 1.625ZM11 13.795C9.02 13.795 7.42 12.185 7.42 10.205C7.42 8.22502 9.02 6.625 11 6.625C12.98 6.625 14.58 8.22502 14.58 10.205C14.58 12.185 12.98 13.795 11 13.795Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProfileIcon);
export default __webpack_public_path__ + "static/media/myProfileIcon.434362067bbcc896ab87e5d3c1efa844.svg";
export { ForwardRef as ReactComponent };